(function () {
  var fired = false;
  var queued = [];
  var seen = new WeakSet();

  var blockedSrcSubstrings = [
    "gorgias.chat",
    "cdn-widgetsrepository.yotpo.com",
    "wrapped-app-embed.js"
  ];

  function cloneScript(original) {
    var s = document.createElement('script');

    for (var i = 0; i < original.attributes.length; i++) {
      var attr = original.attributes[i];
      s.setAttribute(attr.name, attr.value);
    }

    if (original.src) {
      s.src = original.src;
    } else {
      s.textContent = original.textContent;
    }

    return s;
  }

  function isBlockedBySrc(node) {
    if (!node || !node.src) return false;

    var src = node.src.toLowerCase();

    return blockedSrcSubstrings.some(function (fragment) {
      return src.includes(String(fragment).toLowerCase());
    });
  }

  function shouldDelay(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.tagName !== 'SCRIPT') return false;

    if (node.classList && node.classList.contains('ignore')) return false;
    if (node.dataset.deferManaged === 'true') return false;
    if (node.type === 'application/ld+json') return false;
    if (node.hasAttribute('data-keep-critical')) return false;

    /* Blocklist behavior:
       only delay scripts that match the blocked list */
    if (!isBlockedBySrc(node)) return false;

    return true;
  }

  function parkScript(node) {
    if (seen.has(node)) return;
    seen.add(node);

    node.dataset.deferManaged = 'true';

    var placeholder = document.createComment('deferred-script');
    queued.push({
      original: node,
      parent: node.parentNode,
      nextSibling: node.nextSibling,
      placeholder: placeholder
    });

    if (node.parentNode) {
      node.parentNode.replaceChild(placeholder, node);
    }
  }

  function flushQueue() {
    while (queued.length) {
      var item = queued.shift();
      if (!item.parent) continue;

      var script = cloneScript(item.original);
      script.dataset.deferManaged = 'true';

      if (item.placeholder.parentNode) {
        item.placeholder.parentNode.replaceChild(script, item.placeholder);
      } else {
        item.parent.appendChild(script);
      }
    }
  }

  function activate() {
    if (fired) return;
    fired = true;
    observer.disconnect();
    flushQueue();
  }

  function scan(node) {
    if (shouldDelay(node)) {
      parkScript(node);
    }

    if (node.querySelectorAll) {
      node.querySelectorAll('script').forEach(function (script) {
        if (shouldDelay(script)) parkScript(script);
      });
    }
  }

  var observer = new MutationObserver(function (mutations) {
    if (fired) return;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        scan(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(function (eventName) {
    window.addEventListener(eventName, activate, { once: true, passive: true });
  });

  setTimeout(activate, 6000);
})();